import React from 'react'

const NewThemeInfo = () => {
  return (
    <div>
      
    </div>
  )
}

export default NewThemeInfo
